import { useNavigate, Link } from "react-router-dom";
import { LogOut, UserCircle2, KeyRound } from "lucide-react";
import { useAuth } from "../../lib/auth";

export default function ChaplainProfile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/chaplain-portal/login", { replace: true });
  };

  return (
    <div data-testid="chap-profile">
      <h2 className="font-heading text-2xl tracking-tight text-slate-900 flex items-center gap-2">
        <UserCircle2 className="w-6 h-6 text-[#4A6FA5]" strokeWidth={1.75} /> Profile
      </h2>

      <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <div>
          <p className="text-xs uppercase tracking-[0.16em] text-slate-500 font-semibold">Name</p>
          <p className="mt-1 text-sm text-slate-900">{user?.name || "—"}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.16em] text-slate-500 font-semibold">Email</p>
          <p className="mt-1 text-sm text-slate-900">{user?.email || "—"}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.16em] text-slate-500 font-semibold">Role</p>
          <p className="mt-1 text-sm text-slate-900">Chaplain</p>
        </div>
        <div className="pt-4 border-t border-slate-100 flex flex-wrap gap-2">
          <Link
            to="/care-portal/admin/change-password"
            data-testid="chap-profile-change-password"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border border-slate-200 hover:bg-slate-50"
          >
            <KeyRound className="w-4 h-4" /> Change password
          </Link>
          <button
            type="button"
            onClick={doLogout}
            data-testid="chap-profile-signout"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-slate-800 text-white hover:bg-slate-900"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
